// exp_PORTFOLIO-61587_file
import { FC } from 'react';

import { formatCost } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';
import { getVacancyOfTheDayForecast } from 'utils/vacancyOfTheDay';

import { Card, Flex, Text, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { selectVacancyOfTheDayClicks } from 'store/models/vacancyOfTheDay';
import { useSelector } from 'store/utils';

const TrlKeys = {
    title: 'VacancyOfTheDayPage.forecast.title',
    period: 'VacancyOfTheDayPage.forecast.period',
    periodValue: 'VacancyOfTheDayPage.forecast.periodValue',
    impressions: 'VacancyOfTheDayPage.forecast.impressions',
    ctr: 'VacancyOfTheDayPage.forecast.ctr',
    ctrValue: 'VacancyOfTheDayPage.forecast.ctrValue',
};

export const ForecastCard: FC = () => {
    const clicks = useSelector(selectVacancyOfTheDayClicks);

    const forecast = getVacancyOfTheDayForecast(clicks);

    const trls = useTrls();
    const { isMobile } = useBreakpoint();

    const rows = [
        { label: trls(TrlKeys.period), value: trls(TrlKeys.periodValue) },
        { label: trls(TrlKeys.impressions), value: formatCost(forecast.impressions, NON_BREAKING_SPACE) },
        { label: trls(TrlKeys.ctr), value: trls(TrlKeys.ctrValue) },
    ];

    return (
        <div>
            {isMobile && (
                <>
                    <Text typography="label-2-regular">{trls(TrlKeys.title)}</Text>
                    <VSpacing default={12} />
                </>
            )}
            <Card padding={24} stretched borderRadius={20} borderWidth="default" data-qa="vacancy-of-the-day-forecast">
                {!isMobile && (
                    <>
                        <Text typography="subtitle-1-semibold">{trls(TrlKeys.title)}</Text>
                        <VSpacing default={16} />
                    </>
                )}
                <Flex direction="column" gap={8}>
                    {rows.map((row) => (
                        <Flex key={row.label} justify="space-between" gap={12}>
                            <Text typography="label-2-regular" style="secondary">
                                {row.label}
                            </Text>
                            <Text typography="subtitle-1-semibold">{row.value}</Text>
                        </Flex>
                    ))}
                </Flex>
            </Card>
        </div>
    );
};
